import { MatchTeamPlayerList as MatchTeamPlayerListComponent  } from './MatchTeamPlayerList.component'
import { connector } from './MatchTeamPlayerList.connector'

export const MatchTeamPlayerList = connector(MatchTeamPlayerListComponent)